import * as React from "react";
const SvgMan4 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.96 7 10 22h4l2.04-15z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 4,
  r: 2,
  fill: "currentColor"
}));
export default SvgMan4;